import gql from 'graphql-tag'

export const fragmentGear = gql`
	fragment GearDetail on Gear {
		id
		name
		type
		weight
		manufacturer {
			id
			name
		}
	}
`

export const fragmentBackpack = gql`
	fragment BackpackDetail on Backpack {
		id
		description
		water
		food
		totalWeight
		items {
			quantity
			gear {
				...GearDetail
			}
		}
	}
	${fragmentGear}
`

export const queryGearCatalog = gql`
	query gearCatalog($keyword: String, $type: GearType, $limit: Int = 100) {
		gear(keyword: $keyword, type: $type, limit: $limit) {
			...GearDetail
		}
	}
	${fragmentGear}
`

export const queryAdventureBackpack = gql`
	query adventureBackpack($id: ID!) {
		adventure(id: $id) {
			id
			title
			viewerIsParticipant
			viewerBackpack {
				...BackpackDetail
			}
		}
	}
	${fragmentBackpack}
`

export const mutationUpdateBackpack = gql`
	mutation updateBackpack($input: UpdateBackpackInput!) {
		updateBackpack(input: $input) {
			backpack {
				...BackpackDetail
			}
		}
	}
	${fragmentBackpack}
`

export const queryManufacturers = gql`
	query manufacturers($keyword: String, $limit: Int = 100) {
		manufacturers(keyword: $keyword, limit: $limit) {
			id
			name
		}
	}
`

export const mutationCreateManufacturer = gql`
	mutation createManufacturer($input: CreateManufacturerInput!) {
		createManufacturer(input: $input) {
			manufacturer {
				id
				name
			}
		}
	}
`

export const mutationCreateGear = gql`
	mutation createGear($input: CreateGearInput!) {
		createGear(input: $input) {
			gear {
				...GearDetail
			}
		}
	}
	${fragmentGear}
`
